/**
 * The findings a tap can fix.
 *
 * A review that says "swap that overhead for a rangehood" and then makes you find the
 * overhead, open it, and scroll the swap row is a review that gets ignored. Where the fix is
 * one swap with one right answer, the finding carries a button. The swap itself goes through
 * the same `swap` the sheet uses, so the neighbours make room or the fix is refused with the
 * same reason a finger would get.
 *
 * Only the deterministic ones. "Put the dishwasher nearer the sink" has several right
 * answers and is what Design-it-for-me and Ask are for.
 */
export function fixFor(finding, maker) {
  if (!finding?.itemId) return null
  if (finding.code === 'hood') {
    const spec = maker.cabinets.find((c) => c.kind === 'wall' && c.role === 'rangehood')
    return spec ? { label: 'Make it a rangehood', specId: spec.id, runId: finding.runId, itemId: finding.itemId } : null
  }
  if (finding.code === 'corner-unit') {
    const spec = maker.cabinets.find((c) => c.kind === 'base' && c.role === 'corner')
    return spec ? { label: 'Use a corner unit', specId: spec.id, runId: finding.runId, itemId: finding.itemId } : null
  }
  return null
}
